// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2xfeZ","col":"CardReaderDesc_col__1kAcM","label":"CardReaderDesc_label__9ttWa"};